const features = [
  {
    icon: 'ri-links-line',
    title: 'Strong Mill Partnerships',
    text: 'We partner with leading Chinese steel mills to bring you competitive pricing and reliable supply chains — backed by long-term relationships built on trust.',
  },
  {
    icon: 'ri-global-line',
    title: 'Shipped to 50+ Countries',
    text: 'Our logistics network covers major ports worldwide. We handle FOB shipments efficiently, ensuring your steel arrives on time and in perfect condition.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Certified & Inspected',
    text: 'Every order is backed by mill certifications and third-party inspection (SGS, TUV). We verify quality before shipment so you don\'t have to.',
  },
];

export default function LegacySection() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-[1420px] mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-12 items-center">

          {/* Image */}
          <div className="lg:w-1/2 w-full h-[320px] md:h-[400px] rounded-lg overflow-hidden relative flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=professional%20business%20meeting%20office%20China%20steel%20trading%20company%20executives%20shaking%20hands%20steel%20coils%20warehouse%20background%20corporate%20professional%20photography&width=800&height=500&seq=legacy-partner-v3&orientation=landscape"
              alt="Steelinkglobal - Your Steel Partner"
              className="w-full h-full object-cover object-top"
            />
            {/* Stats overlay */}
            <div className="absolute bottom-4 left-4 right-4 flex gap-3">
              {[
                { val: '10+', label: 'Years Experience' },
                { val: '50+', label: 'Countries Served' },
                { val: '100%', label: 'Quality Focus' },
              ].map((stat) => (
                <div key={stat.label} className="flex-1 rounded-lg p-3 text-center" style={{ backgroundColor: '#0a2342' }}>
                  <div className="text-xl font-black text-white">{stat.val}</div>
                  <div className="text-xs font-semibold" style={{ color: '#7eb8f7' }}>{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Text */}
          <div className="lg:w-1/2 text-center lg:text-left">
            <span className="text-xs font-bold tracking-widest uppercase mb-2 block" style={{ color: '#0a2342' }}>About Steelinkglobal</span>
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4">
              Your Trusted Steel Partner in China
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-8">
              We are a steel trading company based in China with over 10 years of experience. We work with top Chinese steel mills to get you the best steel at the best price. Our buyers around the world trust us to deliver on time, every time.
            </p>
            <div className="flex flex-col gap-5">
              {features.map((feature) => (
                <div key={feature.title} className="flex flex-col sm:flex-row gap-4 items-center sm:items-start text-center sm:text-left">
                  <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-lg" style={{ backgroundColor: '#0a2342' }}>
                    <i className={`${feature.icon} text-white text-lg`} />
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-gray-900 mb-1">{feature.title}</h4>
                    <p className="text-xs text-gray-600 leading-relaxed">{feature.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
